export default __webpack_public_path__ + "static/idea 1-fe081ad8dfc1412ad8ce7564b85a8db6.wav";